//customized components are imported like <Cusotmized.componentName/> from styles folder
import React from "react"
import { withTheme } from "styled-components/macro"
import { Grid, Hidden, Toolbar, Badge } from "@material-ui/core"
import * as Customized from "../../styles/components/AppBar/styles"
import { MenuIcon, SearchOutlined, Inbox } from "@iconsGallery"
import TenantRegionDropdown from "../TenantRegionDropdown"
import UserDropdown from "../UserDropDown/UserDropdown"

import { useTranslation } from "react-i18next"

const AppBarComponent = ({ onDrawerToggle }) => {
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <Customized.AppBar position="sticky" elevation={0}>
        <Toolbar>
          <Grid container alignItems="center">
            <Hidden mdUp>
              <Grid item>
                <Customized.IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={onDrawerToggle}
                >
                  <MenuIcon />
                </Customized.IconButton>
              </Grid>
            </Hidden>
            <Grid item xs />
            <Grid item>
              <Customized.Search></Customized.Search>
            </Grid>
            <Grid item style={{ display: "flex", alignItems: "center" }}>
              <>
                {localStorage?.getItem("sourceRole") !== null ? (
                  <>
                    {localStorage
                      ?.getItem("sourceRole")
                      ?.includes("SaaS-Site-Admin") && (
                      <div style={{ marginRight: 10 }}>
                        <TenantRegionDropdown />
                      </div>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </>

              <UserDropdown />
            </Grid>
          </Grid>
        </Toolbar>
      </Customized.AppBar>
    </React.Fragment>
  )
}

export default withTheme(AppBarComponent)
